export const isDatePassed = (dateString) => {
  const today = new Date();
  const target = new Date(dateString);

  // On compare juste les dates sans l'heure
  today.setHours(0, 0, 0, 0);
  target.setHours(0, 0, 0, 0);

  return target < today;
};
